/**
 * Pins JSON data to IPFS via Pinata.
 * Requires REACT_APP_PINATA_API_KEY (JWT) in .env
 * Get your JWT at: https://app.pinata.cloud/developers/keys
 */
export async function pinJsonToPinata(data: object): Promise<string> {
  const pinataJwt = process.env.REACT_APP_PINATA_API_KEY;
  if (!pinataJwt) {
    throw new Error(
      "REACT_APP_PINATA_API_KEY is required. Create a key at https://app.pinata.cloud/developers/keys"
    );
  }

  const res = await fetch("https://api.pinata.cloud/pinning/pinJSONToIPFS", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${pinataJwt}`,
    },
    body: JSON.stringify({
      pinataContent: data,
    }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Pinata upload failed: ${res.status} ${res.statusText}`);
  }

  const json = await res.json();
  return json.IpfsHash;
}
